
import type { Step } from '../../../types/step';

interface StepCardProps {
  step: Step;
  onClick: () => void;
}

export default function StepCard({ step, onClick }: StepCardProps) {
  return (
    <div
      onClick={onClick}
      className={`relative p-6 rounded-3xl transition-all duration-300 cursor-pointer ${
        step.isDone
          ? 'bg-gradient-to-br from-[#F9659C]/10 to-[#ACE0EB]/10 border-2 border-[#F9659C]/30'
          : step.isUnlocked
          ? 'bg-white border-2 border-gray-200 hover:border-[#F9659C] hover:shadow-lg'
          : 'bg-gray-50 border-2 border-gray-100 cursor-not-allowed opacity-60'
      }`}
    >
      {/* Step Number */}
      <div className="flex items-center justify-between mb-4">
        <div
          className={`w-12 h-12 rounded-full flex items-center justify-center text-lg font-bold ${
            step.isDone
              ? 'bg-[#F9659C] text-white'
              : step.isUnlocked
              ? 'bg-[#ACE0EB] text-gray-900'
              : 'bg-gray-200 text-gray-400'
          }`}
        >
          {step.isDone ? (
            <i className="ri-check-line text-2xl"></i>
          ) : step.isUnlocked ? (
            step.id
          ) : (
            <i className="ri-lock-fill text-xl"></i>
          )}
        </div>
        {step.isDone && (
          <i className="ri-medal-fill text-3xl text-[#F9659C]"></i>
        )}
      </div>

      {/* Title */}
      <h3
        className={`text-xl font-bold mb-2 ${
          step.isUnlocked ? 'text-gray-900' : 'text-gray-400'
        }`}
      >
        {step.title}
      </h3>

      {/* Description */}
      <p
        className={`text-sm leading-relaxed ${
          step.isUnlocked ? 'text-gray-600' : 'text-gray-400'
        }`}
      >
        {step.description}
      </p>

      {/* Questions Count */}
      {step.isUnlocked && (
        <div className="mt-4 flex items-center gap-2 text-sm text-gray-500">
          <i className="ri-question-line"></i>
          <span>{step.questions.length} вопросов</span>
        </div>
      )}
    </div>
  );
}
